import React from 'react';


import tryItImg from '../../../../../public/images/index-page/try-it.svg';
import logoImg from '../../../../../public/images/airtourpro-logo.svg';
import phoneMinImg from '../../../../../public/images/index-page/phone-min.webp';
import playMarketImg from '../../../../../public/images/google-play.webp';
import appleStoreImg from '../../../../../public/images/app-store.webp';
import cloudBgWebP from '../../../../../public/images/index-page/cloud-bg.webp';
import contactHeliImg from '../../../../../public/images/index-atp-page/contact-heli.webp';
import appScreen2Img from '../../../../../public/images/index-page/app-screens/app-screen2.webp';
import phoneSilverImg from '../../../../../public/images/index-page/phone-silver.webp';
import appScreen1Img from '../../../../../public/images/index-page/app-screens/app-screen1.webp';
import bookingImg from '../../../../../public/images/index-atp-page/air-ticket-flight-booking-concept.webp';
import weightBalanceImg from '../../../../../public/images/index-atp-page/WeightBalance.webp';
import aboutImgSmall from '../../../../../public/images/index-atp-page/about-img-small-atp.webp';
import aboutImgBig from '../../../../../public/images/index-atp-page/about-img-big-atp.webp';
import heliTopLeft from '../../../../../public/images/index-atp-page/heli-top-left.webp';
import heliTopLeft2x from '../../../../../public/images/index-atp-page/heli-top-left@2x.webp';
import heliTopRight from '../../../../../public/images/index-atp-page/heli-top-right.webp';
import heliTopRight2x from '../../../../../public/images/index-atp-page/heli-top-right@2x.webp';
import heliBottomLeft from '../../../../../public/images/index-atp-page/heli-bottom-left.webp';
import blogFirstImg from '../../../../../public/images/index-atp-page/blog-first-img.webp';
import blogSecondImg from '../../../../../public/images/index-atp-page/blog-second-img.webp';
import blogThirdImg from '../../../../../public/images/index-atp-page/blog-third-img.webp';
import twitterImg from '../../../../../public/images/index-atp-page/twitter.webp';
import bannerMaintenance from '../../../../../public/images/index-atp-page/banner/general_aviation_maintenance_hangar.webp';
import bannerEmployment from '../../../../../public/images/index-atp-page/banner/overview_of_aviation_employment.webp';

const androidAppUrl = 'https://play.google.com/store/apps/details?id=com.holdshort&amp;hl=en_US';
const iosAppUrl = 'https://itunes.apple.com/us/app/holdshort/id1187603879?mt=8';

const howItWorksSec = {
  worksTitleH2: 'How it works',
  worksTextSmall: `FareHarbor, the leading booking platform for the Tours & Activities industry. Sell and distribute your inventory via FareHarbor and manage your aircraft dispatch through AirTourPro.`,
  worksButton: 'Start your free trial here'
};

const howItWorksVideo = {
  workVidAlt: 'AirTourPro Watch demo presentation',
  demoVideoS: 'Holdshort App for Aircraft Scheduling'
};

const journeySec = {
  extLinkBtn: 'https://fareharbor.com/',
  extLinkBtnName: 'Fare Harbor Website'
};
const heroSection = {
  airplaneBg: '/public/images/index-atp-page/airplane-bg-atp.webp',
  tryItImg: tryItImg,
  logoImg: logoImg,
  logoAlt: 'AirTourPro Logo',
  appleStoreLink: iosAppUrl,
  playMarketLink: androidAppUrl,
  phoneMinLinkImg: phoneMinImg,
  phoneLinkTitle: 'AirTourPro App',
  playMarketSrc: playMarketImg,
  playMarketTitle: 'AirTourPro Google Play',
  appleStoreSrc: appleStoreImg,
  appStoreTitle: 'AirTourPro App Store',
  tryItAlt: `AirTour Pro Try it! It's free!`,
  planeAlt: 'AirTour Pro airplane',
  signInHeading: 'Sign in AirTour Pro web version:',
  authForm: '/authorization/login/',
  formSubmit: {
    signInText: 'Sign In',
    signUpText: 'Sign Up for free!',
    forgotPass: 'Forgot Password',
    forgotPassLink: '/authorization/recovery/'
  },
  heading: (
    <span>
      Manage your <b>aircraft operation</b>
      <br />
      anytime, anywhere
    </span>
  ),
  headerText:
    'Cloud-based solution for the management and dispatch of air tours and commercial aviation.'
};
const contactSection = {
  infoContainer: {
    bgImgWebP: cloudBgWebP,
    bgImgPng: cloudBgWebP,
    typePng: 'image/webp',
    alt: 'AirTourPro white cloud',
    heading: 'Contact Us',
    text: 'If you have any questions, comments or suggestions, please feel free to contact us!',
    contactEmailLink: 'support@AirTourPro.com',
    indexContactFollow: 'Follow us:',
    linkTwitter: 'https://twitter.com/AirTourPro',
    hrefTwitter: '/public/images/shapes.svg?v=#twitter',
    linkFb: 'https://www.facebook.com/AirTourPro',
    hrefFb: '/public/images/shapes.svg?v=#facebook',
    linkYT: 'https://www.youtube.com/user/AirTourPro',
    hrefYT: '/public/images/shapes.svg?v=#youtube'
  },
  planeContact: {
    planeImgPng: contactHeliImg,
    planeAlt: 'AirTourPro contact'
  },
  contactAppLinks: {
    iosLink: iosAppUrl,
    iosHref: appleStoreImg,
    iosTitle: 'AirTourPro App Store',
    androidLink: androidAppUrl,
    androidHref: playMarketImg,
    androidTitle: 'AirTourPro Google Play'
  },
  contactAppFigure: {
    phonePinkImg: '',
    phoneAlt: 'AirTourPro demo phone pink',
    appScreenImg: appScreen2Img,
    appAlt: 'AirTourPro contact app'
  },
  tplFooter: {
    footerContainer: (
      <span>
        © 2003 - 2023 AirtourPro Systems, LLC.
        <br />
        All Rights Reserved.
      </span>
    ),
    footerNav: {
      navLinkDoc: '/documentation/',
      navTitleDoc: 'Documentation',
      navLinkContact: '/static/contact-us/',
      navTitleContact: 'Contact Us',
      navLinkTerms: '/static/terms-of-service/',
      navTitleTerms: 'Terms of Service',
      navLinkPrivacy: '/static/privacy-policy/',
      navTitlePrivacy: 'Privacy Policy'
    }
  }
};
const useAppsInfo = {
  iphoneImgPng: {
    img: phoneSilverImg,
    typePng: 'image/png',
    alt: 'AirTourPro phone silver'
  },
  appScreen: {
    img: appScreen1Img,
    alt: 'AirTourPro App Phone',
    typePng: 'image/png'
  },
  useAppContent: {
    textH2: (
      <span>
        Use our apps to <b>schedule</b> <b>a plane</b> anytime, anywhere
      </span>
    ),
    textP: 'For Flight Schools, Flying Clubs, FBOs, Aircraft Partnerships and General Aviation',
    appStoreImg: appleStoreImg,
    linkGplay: androidAppUrl,
    linkAppStore: iosAppUrl,
    appStoreTitle: 'AirTourPro App Store',
    gPlayImg: playMarketImg,
    gPlayTitle: 'AirTourPro Google Play'
  }
};
const banner = [
  {
    name: 'Booking Integration',
    content: `AirTourPro is seamlessly integrated with FareHarbor to sell tour inventory and collect passenger details for aircraft dispatch.`,
    bannerImg: bookingImg
  },
  {
    name: 'Compliance',
    content: `Our aircraft scheduling software offers a wide range of 
        enforcement capabilities (Certificates, Ratings, FAA Flight Review,
        Medical, Organization Review, Renter’s Insurance, etc.) to ensure
        the eligibility of your pilots. In addition, the aircraft 
        hobbs and tach & meter tracking system will keep you notified 
        on maintenance inspections that come due.`,
    bannerImg: bannerMaintenance
  },
  {
    name: 'Versatility',
    content: `The online scheduling software features a multi-tier role system that can be fully customized.
    This way, you can effortlessly distribute responsibilities between managers, instructors, pilots, students,
    etc.&nbsp; Apart from having default resources on the schedule such as aircraft and instructors, you may add
    custom resources such as staff and other equipment for complete scheduling management. Reservations for equipment
    can be made with a scheduled flight.`,
    bannerImg: bannerEmployment
  },
  {
    name: 'Weight And Balance',
    content: `Easily move passengers between seats to balance aircraft.
    Support for all aircraft types, including helicopters with support for dynamic fuel tanks.`,
    bannerImg: weightBalanceImg
  }
];
const aboutSection = {
  aboutCloudBg: cloudBgWebP,
  altCloudBg: 'AirTourPro white cloud',
  readMore: {
    btn: 'Read More >',
    link: '/news/'
  },
  aboutImgs: {
    imgSmallPng: aboutImgSmall,
    dataSrc: aboutImgSmall,
    title: 'AirTourPro About Us small image'
  },
  imgBigFigure: {
    imgBigPng: aboutImgBig,
    dataSrc: aboutImgBig,
    imgBigTitle: 'AirTourPro About Us big image'
  },
  airplaneTopLeft: {
    imgPlanPng:
      `${heliTopLeft}, ${heliTopLeft2x} 2x`,
    dataSrc: heliTopLeft,
    titleTopLeft: 'AirTourPro airplane top left'
  },
  svgSprite: {
    link: '/public/images/shapes.svg?v=#dotted-curve',
    height: '314px',
    width: '325px'
  },
  airplaneTopRight: {
    imgPlanPng:
      `${heliTopRight}, ${heliTopRight2x} 2x`,
    dataSrc: heliTopRight,
    titleTopRight: 'AirTourPro airplane top right'
  },
  airplaneBottomLeft: {
    imgPlanPng: heliBottomLeft,
    dataSrc: heliBottomLeft,
    titleBottomLeft: 'AirTourPro airplane bottom left'
  },

  aboutT: (
    <span>
      <p>
        Our complete air tour management and commercial aircraft scheduling software integrated with
        a leading booking software provides an end-to-end solution to air tour and charter
        operators. Our cloud-based platform available via the web and app provides access to your
        business operation anytime and from anywhere.
      </p>
    </span>
  )
};
const iconsSection = [
  {
    ico: {
      href: '/public/images/shapes.svg?v=#man-with-tie',
      height: '20px',
      width: '26px'
    },
    title: 'Dynamically manage aircraft weight and balance'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#hat',
      height: '30px',
      width: '21px'
    },
    title: 'Unlimited Pilots & Users'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#plane-include',
      height: '25px',
      width: '25px'
    },
    title: 'FAA Certificate Enforcement (Medical, Ratings, & Endorsements)'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#controls',
      height: '20px',
      width: '21px'
    },
    title: 'Complete Scheduling Management Control'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#group',
      height: '31px',
      width: '31px'
    },
    title: 'Complete Maintenance Management'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#call-center-man',
      height: '24px',
      width: '25px'
    },
    title: 'Aircraft Dispatch Control'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#chat-bubbles-with-ellipsis',
      height: '26px',
      width: '20px'
    },
    title: 'Live Customer Support'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#strategy',
      height: '30px',
      width: '34px'
    },
    title: 'Initial Set-Up and Data Migration'
  }
];
const blogItems = [
  {
    name: `Our latest mobile app update's been deployed.`,
    date: 'Mar 29, 2022',
    desc: '',
    img: blogFirstImg
  },
  {
    name: `Our latest update's been released! `,
    date: 'Mar 30, 2022',
    desc: `Enhanced Day View, Basic Med, new payment processor,
    ability to view instructor's w. hours & contact info,
    improved backup reservations are now available in the system!
    The mobile app update is soon to follow!`,
    img: blogSecondImg
  },
  {
    name: '',
    date: 'Mar 29, 2022',
    desc: `It only takes a short press of your finger to #schedule an #aircraft in our mobile app!`,
    img: blogThirdImg
  }
];
const blogRightShape = {
  imgTwPng: twitterImg,
  dataSrc: twitterImg,
  titleTopRight: 'AirTourPro twitter'
};

export {
  howItWorksSec,
  howItWorksVideo,
  journeySec,
  heroSection,
  contactSection,
  useAppsInfo,
  banner,
  aboutSection,
  iconsSection,
  blogItems,
  blogRightShape
};
